import { render, staticRenderFns } from "./addPageDialog.vue?vue&type=template&id=3aa4bbcc&scoped=true"
import script from "./addPageDialog.vue?vue&type=script&lang=js"
export * from "./addPageDialog.vue?vue&type=script&lang=js"
import style0 from "./addPageDialog.vue?vue&type=style&index=0&id=3aa4bbcc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3aa4bbcc",
  null
  
)

export default component.exports